<template>
  <div class="report-template-edit">
    <div class="page-header">
      <div class="title">{{ isEdit ? '编辑填报模板' : '新增填报模板' }}</div>
      <div class="header-btns">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </div>

    <div class="form-container">
      <el-form :model="formData" label-width="100px" :rules="formRules" ref="templateForm">
        <el-form-item label="模板名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        
        <div class="form-row">
          <el-form-item label="适用班组" prop="classIds" class="half-width">
            <el-select v-model="formData.classIds" multiple placeholder="请选择适用班组" style="width: 100%">
              <el-option 
                v-for="item in classList" 
                :key="item.id" 
                :label="item.name" 
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="健康评级" prop="healthRatingId" class="half-width">
            <el-select v-model="formData.healthRatingId" placeholder="请选择健康评级" style="width: 100%">
              <el-option
                v-for="item in healthRatingList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        
        <div class="form-row">
          <el-form-item label="填报方式" prop="fillType" class="half-width">
            <el-radio-group v-model="formData.fillType">
              <el-radio :label="1">按天</el-radio>
              <el-radio :label="2">按班组</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="状态" prop="status" class="half-width">
            <el-radio-group v-model="formData.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="section-container">
      <div class="section-header">
        <div class="section-title">排查状况</div>
        <el-button size="small" type="primary" @click="handleAddHealthCheck">新增</el-button>
      </div>
      <el-table :data="formData.fields" border style="width: 100%">
        <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
        <el-table-column prop="name" label="字段名称(单位)" min-width="220" align="center"></el-table-column>
        <el-table-column prop="typeName" label="类型" width="80" align="center"></el-table-column>
        <el-table-column label="分值设置" min-width="180" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.options && scope.row.options.length > 0">
              <div v-for="(option, index) in scope.row.options" :key="index">
                {{ option.displayName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否需要审批" width="180" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.options && scope.row.options.length > 0">
              <div v-for="(option, index) in scope.row.options" :key="index">
                {{ option.isNeedApproved === 1 ? '需要' : '不需要' }} 
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEditField('field', scope.row)">编辑</el-button>
            <el-button type="text" class="delete-btn" @click="handleDeleteField('field', scope.$index)">
               删除
            </el-button>
            <el-button type="text" v-if="scope.$index > 0" @click="handleMoveUp('field', scope.$index)">上移</el-button>
            <el-button type="text" v-if="scope.$index < formData.fields.length - 1" @click="handleMoveDown('field', scope.$index)">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="section-container">
      <div class="section-header">
        <div class="section-title">管控措施</div>
        <el-button size="small" type="primary" @click="handleAddControlMeasure">新增</el-button>
      </div>
      <el-table :data="formData.measures" border style="width: 100%">
        <el-table-column prop="sort" label="排序" width="70" align="center"></el-table-column>
        <el-table-column prop="name" label="管控措施内容" min-width="300" align="center"></el-table-column>
        <el-table-column label="分值" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.score }}分
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEditField('measure', scope.row)">编辑</el-button>
            <el-button type="text" class="delete-btn" @click="handleDeleteField('measure', scope.$index)">
               删除
            </el-button>
            <el-button type="text" v-if="scope.$index > 0" @click="handleMoveUp('measure', scope.$index)">上移</el-button>
            <el-button type="text" v-if="scope.$index < formData.measures.length - 1" @click="handleMoveDown('measure', scope.$index)">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 排查状况字段编辑弹窗 -->
    <el-dialog 
      :title="fieldDialogType === 'add' ? '新增排查状况' : '编辑排查状况'" 
      :visible.sync="healthFieldDialogVisible" 
      width="650px" 
      custom-class="health-field-dialog"
      :close-on-click-modal="false"
      @close="resetCurrentField">
      
      <div class="dialog-content">
        <!-- 基本信息区域 -->
        <div class="form-section">
          <!-- 字段名称和类型在同一行 -->
          <el-form :model="currentField" ref="healthFieldForm" label-width="80px" label-position="left" :rules="fieldRules">
            <!-- 字段名称 -->
            <el-form-item label="字段名称" prop="name" class="required-label">
              <el-input 
                v-model="currentField.name" 
                placeholder="请输入字段名称，例如：血压(mmHg)">
              </el-input>
            </el-form-item>
            
            <!-- 字段类型 -->
            <el-form-item label="字段类型" prop="type" class="required-label">
              <el-radio-group v-model="currentField.type" @change="handleFieldTypeChange">
                <el-radio :label="1">数字</el-radio>
                <el-radio :label="2">选择</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        
        <!-- 数字类型的分值设置 -->
        <template v-if="currentField.type === 1">
          <div class="form-section">
            <div class="section-header">
              <div class="section-title">分值设置</div>
              <el-button type="primary" plain size="small" @click="addNumberScoreRule" class="add-rule-btn">
                <i class="el-icon-plus"></i> 新增分值规则
              </el-button>
            </div>
            
            <!-- 分值规则列表 -->
            <div class="rules-list">
              <div v-for="(rule, index) in currentField.options" :key="'num-rule-'+index" class="rule-row">
                <el-select v-model="rule.operatorType" placeholder="请选择" class="condition-select">
                  <el-option label="请选择" :value="null" disabled></el-option>
                  <el-option label=">=" :value="1"></el-option>
                  <el-option label="<" :value="2"></el-option>
                </el-select>
                
                <el-input v-model.number="rule.operatorValue" placeholder="数值" class="value-input" 
                  @input="validateNumber(rule, 'operatorValue')"></el-input>
                
                <div class="score-input-group">
                  <el-input v-model.number="rule.score" type="number" min="0" placeholder="分值" class="score-input" style="width:100px" />
                  <span class="score-unit">分</span>
                </div>
                
                <div class="approval-checkbox">
                  <el-checkbox
                    v-model="rule.isNeedApproved"
                    :true-label="1"
                    :false-label="0"
                  >
                    需要审批
                  </el-checkbox>
                </div>
                
                <div class="action-field">
                  <el-button 
                    type="danger" 
                    icon="el-icon-delete" 
                    circle 
                    size="mini" 
                    @click="removeNumberScoreRule(index)"
                    v-if="currentField.options.length > 1">
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </template>
        
        <!-- 选择类型的选项设置 -->
        <template v-if="currentField.type === 2">
          <div class="form-section">
            <div class="section-header">
              <div class="section-title">选项设置</div>
              <el-button type="primary" plain size="small" @click="addOptionRule" class="add-rule-btn">
                <i class="el-icon-plus"></i> 新增选项
              </el-button>
            </div>
            
            <!-- 选项列表 -->
            <div class="rules-list">
              <div v-for="(option, index) in currentField.options" :key="'option-'+index" class="rule-row">
                <!-- 选项内容输入框 -->
                <el-input 
                  v-model="option.optionName" 
                  placeholder="选项内容" 
                  class="option-input"
                  style="width: 50% !important; min-width: 300px !important;">
                </el-input>
                
                <!-- 分值输入组 -->
                <div class="score-input-group">
                  <el-input v-model.number="option.score" type="number" min="0" placeholder="分值" class="score-input" style="width:100px" />
                  <span class="score-unit">分</span>
                </div>
                
                <!-- 是否需要审批 -->
                <div class="approval-checkbox">
                  <el-checkbox
                    v-model="option.isNeedApproved"
                    :true-label="1"
                    :false-label="0"
                  >
                    需要审批
                  </el-checkbox>
                </div>
                
                <!-- 删除按钮 -->
                <el-button 
                  type="danger" 
                  icon="el-icon-delete" 
                  circle 
                  size="mini" 
                  @click="removeOptionRule(index)"
                  v-if="currentField.options.length > 1">
                </el-button>
              </div>
            </div>
          </div>
        </template>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="healthFieldDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitHealthField">确定</el-button>
      </div>
    </el-dialog>

    <!-- 管控措施字段编辑弹窗 -->
    <el-dialog :title="fieldDialogType === 'add' ? '新增管控措施' : '编辑管控措施'" :visible.sync="controlFieldDialogVisible" width="50%">
      <el-form :model="currentField" label-width="100px" :rules="controlFieldRules" ref="controlFieldForm">
        <el-form-item label="措施内容" prop="name">
          <el-input v-model="currentField.name" placeholder="请输入管控措施内容"></el-input>
        </el-form-item>
        <el-form-item label="分值" prop="score">
          <el-input v-model.number="currentField.score" type="number" min="0" placeholder="请输入分值" class="score-input" style="width:100px" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="controlFieldDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitControlField">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getReportTemplateById, createReportTemplate, updateReportTemplate } from '@/api/report'
import { getAllHealthRatings } from '@/api/health-rating'
import { getAllClasses } from '@/api/class'

export default {
  name: 'ReportTemplateEdit',
  data() {
    return {
      isEdit: this.$route.query.id ? true : false,
      formData: {
        id: this.$route.query.id || null,
        name: '',
        healthRatingId: null,
        classIds: [],
        fillType: 1,
        status: 1,
        fields: [],
        measures: []
      },
      formRules: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        healthRatingId: [{ required: true, message: '请选择健康评级', trigger: 'change' }],
        classIds: [{ required: true, message: '请选择适用班组', trigger: 'change' }],
        fillType: [{ required: true, message: '请选择填报方式', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      classList: [], // 班组列表
      healthRatingList: [], // 健康评级列表
      
      // 字段编辑相关
      fieldDialogType: 'add', // 'add' 或 'edit'
      healthFieldDialogVisible: false,
      controlFieldDialogVisible: false,
      currentField: {},
      currentFieldIndex: -1,
      fieldRules: {
        name: [{ required: true, message: '请输入字段名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }]
      },
      controlFieldRules: {
        name: [{ required: true, message: '请输入管控措施内容', trigger: 'blur' }],
        score: [{ required: true, message: '请输入分值', trigger: 'blur' }]
      },
      loading: false
    }
  },
  created() {
    // 获取班组列表和健康评级列表
    this.fetchClassList()
    this.fetchHealthRatingList()
    
    // 如果是编辑模式，根据ID获取模板数据
    if (this.isEdit) {
      this.fetchTemplateData()
    }
  },
  methods: {
    // 获取班组列表
    fetchClassList() {
      getAllClasses()
        .then(response => {
          if (response.code === 200 && response.data) {
            this.classList = response.data
          } else {
            this.$message.error('获取班组列表失败')
          }
        })
        .catch(error => {
          console.error('获取班组列表失败:', error)
          this.$message.error('获取班组列表失败')
        })
    },
    
    // 获取健康评级列表
    fetchHealthRatingList() {
      getAllHealthRatings()
        .then(response => {
          if (response.code === 200 && response.data) {
            this.healthRatingList = response.data
          } else {
            this.$message.error('获取健康评级列表失败')
          }
        })
        .catch(error => {
          console.error('获取健康评级列表失败:', error)
          this.$message.error('获取健康评级列表失败')
        })
    },
    
    // 获取模板数据
    fetchTemplateData() {
      this.loading = true
      getReportTemplateById(this.formData.id)
        .then(response => {
          if (response.code === 200) {
            const data = response.data
            
            // 填充基本信息
            this.formData = {
              id: data.id,
              name: data.name,
              healthRatingId: data.healthRatingId,
              classIds: data.classIds || [],
              fillType: data.fillType,
              status: data.status,
              fields: data.fields || [],
              measures: data.measures || []
            }
            
            // 确保字段有排序字段
            if (this.formData.fields && this.formData.fields.length > 0) {
              this.formData.fields.forEach((item, index) => {
                if (!item.sort) {
                  item.sort = index + 1
                }
                
                // 处理选项数据中的isNeedApproved字段
                if (item.options && item.options.length > 0) {
                  console.log(`加载时处理字段[${item.name}]的选项数据:`, JSON.stringify(item.options));
                  
                  item.options.forEach(option => {
                    const originalValue = option.isNeedApproved;
                    
                    // 确保isNeedApproved是整数类型
                    if (option.isNeedApproved === undefined || option.isNeedApproved === null) {
                      option.isNeedApproved = 0
                    } else if (typeof option.isNeedApproved === 'boolean') {
                      option.isNeedApproved = option.isNeedApproved ? 1 : 0
                    } else if (typeof option.isNeedApproved === 'string') {
                      // 处理可能的字符串值
                      option.isNeedApproved = option.isNeedApproved === '1' || option.isNeedApproved.toLowerCase() === 'true' ? 1 : 0;
                    } else {
                      // 确保是0或1的整数
                      option.isNeedApproved = Number(option.isNeedApproved) === 1 ? 1 : 0;
                    }
                    
                    console.log(`选项[${option.optionName || '数字选项'}] isNeedApproved: ${originalValue} -> ${option.isNeedApproved}`);
                    
                    // 更新displayName，包含审批状态
                    if (item.type === 1) { // 数字类型
                      const operatorSymbol = option.operatorType === 1 ? '>=' : '<'
                      option.displayName = `${operatorSymbol}${option.operatorValue}: ${option.score}分`
                    } else { // 选择类型
                      option.displayName = `${option.optionName}: ${option.score}分`
                    }
                  })
                  
                  console.log(`处理后字段[${item.name}]的选项:`, item.options);
                }
              })
            }
            
            // 确保管控措施有排序字段
            if (this.formData.measures && this.formData.measures.length > 0) {
              this.formData.measures.forEach((item, index) => {
                if (!item.sort) {
                  item.sort = index + 1
                }
              })
            }
          } else {
            this.$message.error(response.message || '获取模板数据失败')
          }
        })
        .catch(error => {
          console.error('获取模板数据失败:', error)
          this.$message.error('获取模板数据失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    
    // 取消
    handleCancel() {
      this.$confirm('确认取消操作？未保存的数据将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back();
      }).catch(() => {})
    },
    
    // 保存模板
    handleSave() {
      this.$refs.templateForm.validate((valid) => {
        if (valid) {
          // 检查是否有字段和管控措施
          if (this.formData.fields.length === 0) {
            this.$message.warning('请至少添加一个排查状况字段')
            return false
          }
          if (this.formData.measures.length === 0) {
            this.$message.warning('请至少添加一个管控措施')
            return false
          }
          // 校验所有排查状况字段最大分值之和不得超过100分
          let totalMaxScore = 0;
          this.formData.fields.forEach(field => {
            if (field.options && field.options.length > 0) {
              const maxScore = (Math.max(...(field.options.map(opt => Number(opt.score) || 0))));
              totalMaxScore += maxScore;
            }
          });
          let totalMeasureScore = 0;
          this.formData.measures.forEach(measure => { totalMeasureScore += (Number(measure.score) || 0); });
          const totalScore = totalMaxScore + totalMeasureScore;
          if (totalScore > 100) {
             this.$message.warning('排查状况最大分值与管控措施分值总和不能超过100分');
             return false;
          }
          this.$confirm('确认保存模板配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.saveTemplate()
          }).catch(() => {})
        } else {
          return false
        }
      })
    },
    
    // 保存模板数据到服务器
    saveTemplate() {
      this.loading = true
      
      // 构建提交的数据
      const submitData = {
        ...this.formData,
        // 确保字段和管控措施有正确的排序号，并且所有isNeedApproved都是整数
        fields: this.formData.fields.map((item, index) => {
          const field = {
            ...item,
            sort: index + 1
          }
          
          // 处理选项中的isNeedApproved，确保是整数
          if (field.options && field.options.length > 0) {
            console.log(`保存前处理字段[${field.name}]的选项:`, field.options);
            
            field.options = field.options.map(option => {
              const originalValue = option.isNeedApproved;
              
              // 将布尔值或null值转换为整数
              if (typeof option.isNeedApproved === 'boolean') {
                option.isNeedApproved = option.isNeedApproved ? 1 : 0
              } else if (option.isNeedApproved === null || option.isNeedApproved === undefined) {
                option.isNeedApproved = 0
              } else if (typeof option.isNeedApproved === 'string') {
                // 处理可能的字符串值
                option.isNeedApproved = option.isNeedApproved === '1' || option.isNeedApproved.toLowerCase() === 'true' ? 1 : 0;
              } else {
                // 强制转换为0或1
                option.isNeedApproved = Number(option.isNeedApproved) === 1 ? 1 : 0;
              }
              
              console.log(`选项[${option.optionName || '数字选项'}] isNeedApproved: ${originalValue} -> ${option.isNeedApproved}`);
              return option
            })
            
            console.log(`处理后字段[${field.name}]的选项:`, field.options);
          }
          
          return field
        }),
        measures: this.formData.measures.map((item, index) => ({
          ...item,
          sort: index + 1
        }))
      }

      console.log('提交的最终数据(查看isNeedApproved):', JSON.stringify(submitData.fields.map(f => ({
        name: f.name,
        options: f.options ? f.options.map(o => ({
          name: o.optionName || '数字选项',
          isNeedApproved: o.isNeedApproved,
          type: typeof o.isNeedApproved
        })) : []
      }))));
      
      const savePromise = this.isEdit
        ? updateReportTemplate(this.formData.id, submitData)
        : createReportTemplate(submitData)
      
      savePromise
        .then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.$router.back()
          } else {
            this.$message.error(response.message || '保存失败')
          }
        })
        .catch(error => {
          console.error('保存模板失败:', error)
          this.$message.error('保存失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    
    // 添加排查状况字段
    handleAddHealthCheck() {
      this.fieldDialogType = 'add'
      this.currentField = {
        name: '',
        type: 1, // 1数字 2选择
        typeName: '数字',
        options: [{ operatorType: null, operatorValue: '', score: 0, isNeedApproved: 0 }]
      }
      this.currentFieldIndex = -1
      this.healthFieldDialogVisible = true
    },
    
    // 添加管控措施
    handleAddControlMeasure() {
      this.fieldDialogType = 'add'
      this.currentField = {
        name: '',
        score: 0
      }
      this.currentFieldIndex = -1
      this.controlFieldDialogVisible = true
    },
    
    // 编辑字段
    handleEditField(type, row) {
      this.fieldDialogType = 'edit'
      // 深拷贝，避免引用残留
      this.currentField = JSON.parse(JSON.stringify(row))
      if (type === 'field') {
        this.currentFieldIndex = this.formData.fields.findIndex(item => item.sort === row.sort)
        if (!this.currentField.options || this.currentField.options.length === 0) {
          if (this.currentField.type === 1) {
            this.currentField.options = [{ operatorType: null, operatorValue: '', score: 0, isNeedApproved: 0 }]
          } else {
            this.currentField.options = [{ optionName: '', score: 0, isNeedApproved: 0 }]
          }
        }
        // 彻底重置isNeedApproved，防止脏数据
        this.currentField.options.forEach(option => {
          if (option.isNeedApproved === undefined || option.isNeedApproved === null) {
            option.isNeedApproved = 0
          } else if (typeof option.isNeedApproved === 'boolean') {
            option.isNeedApproved = option.isNeedApproved ? 1 : 0
          } else if (typeof option.isNeedApproved === 'string') {
            option.isNeedApproved = option.isNeedApproved === '1' || option.isNeedApproved.toLowerCase() === 'true' ? 1 : 0
          } else {
            option.isNeedApproved = Number(option.isNeedApproved) === 1 ? 1 : 0
          }
        })
        this.healthFieldDialogVisible = true
      } else {
        this.currentFieldIndex = this.formData.measures.findIndex(item => item.sort === row.sort)
        if (this.currentField.score === '' || this.currentField.score === null || typeof this.currentField.score !== 'number' || isNaN(this.currentField.score)) {
          this.currentField.score = 0
        }
        this.controlFieldDialogVisible = true
      }
    },
    
    // 删除字段
    handleDeleteField(type, index) {
      this.$confirm('确认删除该字段?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type === 'field') {
          this.formData.fields.splice(index, 1)
          // 重新排序
          this.formData.fields.forEach((item, idx) => {
            item.sort = idx + 1
          })
        } else {
          this.formData.measures.splice(index, 1)
          // 重新排序
          this.formData.measures.forEach((item, idx) => {
            item.sort = idx + 1
          })
        }
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    
    // 上移字段
    handleMoveUp(type, index) {
      if (index > 0) {
        if (type === 'field') {
          // 交换位置
          const temp = this.formData.fields[index];
          this.formData.fields.splice(index, 1);
          this.formData.fields.splice(index - 1, 0, temp);
          
          // 更新排序号
          this.formData.fields.forEach((item, idx) => {
            item.sort = idx + 1;
          });
        } else {
          // 交换位置
          const temp = this.formData.measures[index];
          this.formData.measures.splice(index, 1);
          this.formData.measures.splice(index - 1, 0, temp);
          
          // 更新排序号
          this.formData.measures.forEach((item, idx) => {
            item.sort = idx + 1;
          });
        }
      }
    },
    
    // 下移字段
    handleMoveDown(type, index) {
      if (type === 'field' && index < this.formData.fields.length - 1) {
        // 交换位置
        const temp = this.formData.fields[index];
        this.formData.fields.splice(index, 1);
        this.formData.fields.splice(index + 1, 0, temp);
        
        // 更新排序号
        this.formData.fields.forEach((item, idx) => {
          item.sort = idx + 1;
        });
      } else if (type === 'measure' && index < this.formData.measures.length - 1) {
        // 交换位置
        const temp = this.formData.measures[index];
        this.formData.measures.splice(index, 1);
        this.formData.measures.splice(index + 1, 0, temp);
        
        // 更新排序号
        this.formData.measures.forEach((item, idx) => {
          item.sort = idx + 1;
        });
      }
    },
    
    // 提交排查状况字段
    submitHealthField() {
      this.$refs.healthFieldForm.validate((valid) => {
        if (valid) {
          // 验证所有规则是否都已选择操作符
          if (this.currentField.type === 1) {
            for (const rule of this.currentField.options) {
              if (!rule.operatorType) {
                this.$message.warning('请为所有分值规则选择比较运算符');
                return false;
              }
              if (rule.operatorValue === '' || isNaN(rule.operatorValue)) {
                this.$message.warning('请为所有分值规则输入有效的数值');
                return false;
              }
              if (rule.score === '' || isNaN(rule.score) || rule.score < 0 || !Number.isInteger(Number(rule.score))) {
                this.$message.warning('请为所有分值规则输入有效的非负整数分值');
                return false;
              }
            }
          } else if (this.currentField.type === 2) {
            for (const option of this.currentField.options) {
              if (!option.optionName.trim()) {
                this.$message.warning('请为所有选项输入有效的选项内容');
                return false;
              }
              if (option.score === '' || isNaN(option.score) || option.score < 0 || !Number.isInteger(Number(option.score))) {
                this.$message.warning('请为所有选项输入有效的非负整数分值');
                return false;
              }
            }
          }
          
          // 设置typeName
          this.currentField.typeName = this.currentField.type === 1 ? '数字' : '选择'
          
          // 确保所有选项的isNeedApproved是数字（0或1）
          if (this.currentField.options && this.currentField.options.length > 0) {
            console.log('提交前，处理isNeedApproved:', this.currentField.options);
            
            this.currentField.options.forEach(option => {
              // 确保是数字类型，0或1
              if (typeof option.isNeedApproved === 'boolean') {
                option.isNeedApproved = option.isNeedApproved ? 1 : 0;
              } else if (option.isNeedApproved === null || option.isNeedApproved === undefined) {
                option.isNeedApproved = 0;
              } else {
                // 强制转换为数字
                option.isNeedApproved = option.isNeedApproved === 1 ? 1 : 0;
              }
              console.log('选项的isNeedApproved处理后:', option.optionName || '数字选项', option.isNeedApproved, typeof option.isNeedApproved);
              
              // 更新displayName
              if (this.currentField.type === 1) { // 数字类型
                const operatorSymbol = option.operatorType === 1 ? '>=' : '<'
                option.displayName = `${operatorSymbol}${option.operatorValue}: ${option.score}分`
              } else { // 选择类型
                option.displayName = `${option.optionName}: ${option.score}分`
              }
            });
            
            console.log('处理后的选项数据:', this.currentField.options);
          }
          
          if (this.fieldDialogType === 'add') {
            // 添加新字段
            const newField = {
              ...this.currentField,
              sort: this.formData.fields.length + 1
            }
            this.formData.fields.push(newField)
          } else {
            // 更新字段 - 修复更新问题
            // 创建一个全新的字段对象，而不是合并现有对象
            const updatedField = {
              ...this.currentField,
              // 确保排序值保持不变
              sort: this.formData.fields[this.currentFieldIndex].sort
            }
            
            // 使用Vue的响应式方法替换数组中的元素，确保视图更新
            this.$set(this.formData.fields, this.currentFieldIndex, updatedField)
          }
          
          this.healthFieldDialogVisible = false
          this.$message.success(this.fieldDialogType === 'add' ? '添加成功' : '更新成功')
        } else {
          return false
        }
      })
    },
    
    // 提交管控措施字段
    submitControlField() {
      this.$refs.controlFieldForm.validate((valid) => {
        if (valid) {
          // 验证分值是否为正整数
          if (
            this.currentField.score === '' ||
            isNaN(this.currentField.score) ||
            this.currentField.score < 0 ||
            !Number.isInteger(this.currentField.score)
          ) {
            this.$message.warning('请输入有效的非负整数分值');
            return false;
          }
          
          // 处理displayName
          this.currentField.displayName = `${this.currentField.name}: ${this.currentField.score}分`
          
          if (this.fieldDialogType === 'add') {
            // 添加新字段
            const newField = {
              ...this.currentField,
              sort: this.formData.measures.length + 1
            }
            this.formData.measures.push(newField)
          } else {
            // 更新字段 - 修复更新问题
            // 创建一个全新的字段对象，而不是合并现有对象
            const updatedField = {
              ...this.currentField,
              // 确保排序值保持不变
              sort: this.formData.measures[this.currentFieldIndex].sort
            }
            
            // 使用Vue的响应式方法替换数组中的元素，确保视图更新
            this.$set(this.formData.measures, this.currentFieldIndex, updatedField)
          }
          this.controlFieldDialogVisible = false
          this.$message.success(this.fieldDialogType === 'add' ? '添加成功' : '更新成功')
        } else {
          return false
        }
      })
    },
    
    // 处理字段类型变化
    handleFieldTypeChange(type) {
      if (type === 1) { // 数字类型
        this.currentField.options = [{ operatorType: null, operatorValue: '', score: 0, isNeedApproved: 0 }]
        this.currentField.typeName = '数字'
      } else { // 选择类型
        this.currentField.options = [{ optionName: '', score: 0, isNeedApproved: 0 }]
        this.currentField.typeName = '选择'
      }
    },
    
    // 添加数字类型的分值规则
    addNumberScoreRule() {
      this.currentField.options.push({ operatorType: null, operatorValue: '', score: 0, isNeedApproved: 0 })
    },
    
    // 移除数字类型的分值规则
    removeNumberScoreRule(index) {
      this.currentField.options.splice(index, 1)
    },
    
    // 添加选项
    addOptionRule() {
      this.currentField.options.push({ optionName: '', score: 0, isNeedApproved: 0 })
    },
    
    // 移除选项
    removeOptionRule(index) {
      this.currentField.options.splice(index, 1)
    },

    // 验证数值类型
    validateNumber(item, field) {
      if (isNaN(item[field])) {
        item[field] = '';
        this.$message.warning('请输入有效的数值');
      }
    },

    // 验证正整数
    validateInteger(item, field) {
      const value = item[field];
      if (isNaN(value) || value < 0 || !Number.isInteger(value)) {
        item[field] = '';
        this.$message.warning('请输入非负整数');
      }
    },

    resetCurrentField() {
      this.currentField = {};
      this.currentFieldIndex = -1;
    },
  }
}
</script>

<style lang="scss" scoped>
.report-template-edit {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.form-container {
  margin-bottom: 30px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.half-width {
  width: 50%;
}

.section-container {
  margin-bottom: 30px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.delete-btn {
  color: #F56C6C;
}

::v-deep .el-button--text {
  &.delete-btn {
    color: #F56C6C;
  }
}

::v-deep .el-button.el-button--danger.is-circle {
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  box-sizing: border-box !important;
  background-color: #F56C6C !important;
  border-color: #F56C6C !important;
}

::v-deep .el-button.el-button--danger.is-circle i {
  font-size: 12px !important;
  margin: 0 !important;
  line-height: 1 !important;
  color: #fff !important;
}

.action-field {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }
  
  .half-width {
    width: 100%;
  }
}

.settings-header-wrapper {
  position: relative;
}

.settings-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.settings-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.settings-button-wrapper {
  position: absolute;
  right: 0;
}

.settings-button {
  margin-left: 10px;
}

.score-settings {
  margin-bottom: 20px;
}

.score-rule-item {
  margin-bottom: 10px;
}

.rule-label {
  width: 100px;
  margin-right: 10px;
}

.rule-condition {
  width: 100px;
}

.rule-value {
  width: 100px;
}

.rule-score {
  width: 100px;
}

.delete-rule-btn {
  margin-left: 10px;
}

.error-message {
  color: #F56C6C;
  margin-top: 10px;
}

.health-field-form {
  padding: 20px;
}

.required-label {
  margin-bottom: 10px;
}

.option-input {
  width: 100px;
}

.rule-input-row {
  display: flex;
  gap: 10px;
}

.health-field-dialog {
  /* Add your styles here */
}

.form-section {
  /* Add your styles here */
}

.section-header {
  /* Add your styles here */
}

.section-title {
  /* Add your styles here */
}

.add-rule-btn {
  /* Add your styles here */
}

.rules-container {
  /* Add your styles here */
}

.rule-item {
  /* Add your styles here */
}

.rule-content {
  /* Add your styles here */
}

.form-card {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.form-grid {
  display: flex;
  gap: 20px;
}

.required-item {
  width: 50%;
}

.custom-input {
  width: 100%;
}

.custom-radio-group {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.add-btn {
  margin-left: 10px;
}

.rules-list {
  margin-bottom: 20px;
}

.rule-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.condition-select {
  width: 100px;
}

.value-input {
  width: 100px;
}

.score-wrapper {
  width: 100px;
}

.score-input {
  width: 100px;
}

.error-alert {
  color: #F56C6C;
  margin-top: 10px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.cancel-btn {
  margin-right: 10px;
}

.confirm-btn {
  /* Add your styles here */
}

.field-layout {
  display: flex;
  gap: 20px;
}

.field-column {
  width: 50%;
}

.field-type {
  width: 50%;
}

.form-label {
  margin-bottom: 10px;
}

.form-input {
  width: 100%;
}

.score-unit {
  margin-left: 10px;
}

.approval-checkbox {
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  align-items: center;
}
</style> 
